module.exports = __webpack_public_path__ + "img/Component 21.3870c722.png";